import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59a24c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "job-post-company" }
const _hoisted_2 = { class: "job-post-title" }
const _hoisted_3 = { class: "job-post-tags" }
const _hoisted_4 = { class: "job-post-location" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ic ic-pin s" }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "job-post-data"
}
const _hoisted_7 = ["status"]
const _hoisted_8 = {
  key: 0,
  class: "job-post-info"
}
const _hoisted_9 = {
  key: 1,
  class: "job-post-info"
}


import { Job } from '../types/Job';

interface Props {
  post: Job;
  editMode?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'JobPost',
  props: {
    post: {},
    editMode: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "job-post",
    to: `${_ctx.editMode ? '/account' : ''}/jobs/${_ctx.post.slug}`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.post.company.company_name), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.post.title), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.post.categories, (category) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "job-post-tag",
            key: category
          }, _toDisplayString(category), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.post.location), 1)
      ]),
      (_ctx.editMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "job-post-info",
              status: _ctx.post.active ? 'active' : 'pending'
            }, _toDisplayString(_ctx.post.active ? 'Published' : 'In Review'), 9, _hoisted_7),
            (_ctx.post.active)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.post.views) + " views", 1))
              : _createCommentVNode("", true),
            (_ctx.post.active)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.post.clicks) + " clicks", 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})